import { render, staticRenderFns } from "./AreasModuleEdit.vue?vue&type=template&id=c79396bc"
import script from "./AreasModuleEdit.vue?vue&type=script&lang=js"
export * from "./AreasModuleEdit.vue?vue&type=script&lang=js"
import style0 from "./AreasModuleEdit.vue?vue&type=style&index=0&id=c79396bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports